Controller.$inject = [];

function Controller() {

}

export function HuiMenu() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            menuAlignment: '@',
            maxHeight: '@?'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            'header': '?huiMenuHeader',
            'footer': '?huiMenuFooter'
        },
        template: ($element, $attrs) => {
            return `<div class="hui hui-menu dropdown-menu"
                         ng-class="{ 'dropdown-menu-right': $huiCtrl.menuAlignment === 'right' }">
                        <div ng-transclude="header"></div>
                        <div class="hui-menu-content" 
                             ng-style="{'max-height': $huiCtrl.maxHeight || '300px'}" 
                             ng-transclude></div>
                        <div ng-transclude="footer"></div>
                    </div>`;
        }
    };
}